import { render, staticRenderFns } from "./TopClients.vue?vue&type=template&id=5f64761a"
import script from "./TopClients.vue?vue&type=script&lang=js"
export * from "./TopClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports